import { useNavigate } from 'react-router-dom';
import CreateWithdrawel from '../withdrawals/components/CreateWithdrawel';

export default function PixBankDataPage() {
  const navigate = useNavigate();
  return <CreateWithdrawel onClose={() => navigate('/access/saques')} asPage />;
}
